export default "__VITE_ASSET__DCeJPJQ5__"